// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8747":"42d54e30","9400":"cf22c0c8"}[chunkId] + ".chunk.css";
};